import React, { useState, useEffect } from "react";
import { Card, Tabs, Dropdown, Menu, Spin } from "antd";
import GainIcon from "../../components/gainicon";

import ActivityChart from "../activity/charts";
import Filter from "./filter";

import { getScenarios, getActivity } from "../../services/api";
import Datatable from "./datatable";
import Description from "./description";
import Graph from "./graph";

const { TabPane } = Tabs;

const ActivityContext = React.createContext();

export default function Index(props) {
  const filter = {
    sectors: [
      "TRA_RD_HDB",
      "TRA_RD_HDT",
      "TRA_RD_LD4C",
      "TRA_RD_LD4T",
      "TRA_RD_M4",
    ],
    rangestart: 2010,
    rangeend: 2050,
    activities: ["GAS", "GSL", "LPG", "MD"],
    sheet: "1. FC",
  };

  const [filterData, setFilterData] = useState(filter);

  const [Tabkey, setTabkey] = useState(1);
  const [ChartType, setChartType] = useState("column");

  const [data, setData] = useState([]);
  const [ChartLoading, setChartLoading] = useState(false);

  useEffect(() => {
    ActivityData();
  }, [filterData]);

  const ActivityData = async () => {
    setChartLoading(true);
    // if (filterData?.scenarios.length > 0) {
    const res = await getActivity(filterData);
    if (res.status === 200) {
      // console.log(res);
      setData(res.data);
      setChartLoading(false);
    }
    // } else {
    //   setChartLoading(false);
    //   setData([]);
    // }
  };

  const chartSelect = (
    <Dropdown
      overlay={
        <Menu className="bg-gain rounded-lg">
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setChartType("column")}
          >
            <span>Stacked column</span>
          </Menu.Item>
          <Menu.Item
            className="text-white hover:bg-blue-900"
            onClick={() => setChartType("bar")}
          >
            <span>Stacked bar</span>
          </Menu.Item>
        </Menu>
      }
      placement="bottomCenter"
      arrow
      trigger={["click"]}
    >
      <div className="cursor-pointer select-none">
        <GainIcon name="chart-dropdown" />
      </div>
    </Dropdown>
  );

  return (
    <ActivityContext.Provider
      value={{
        defaults: filter,
        filterData,
        setFilterData,
        ActivityData,
        data: data,
      }}
    >
      {!props.embed && <h1 className="text-3xl font-bold">Activity data</h1>}
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-6 pt-8">
        <Card
          title={false}
          className="border-none rounded-lg col-span-2 2xl:col-span-3 px-6 py-3"
        >
          <Tabs
            defaultActiveKey="1"
            tabBarExtraContent={Tabkey == 1 && chartSelect}
            onChange={(key) => setTabkey(key)}
          >
            <TabPane tab="Charts" key="1">
              <Spin tip="Data Loading..." spinning={ChartLoading}>
                <div className="pt-12">
                  <ActivityChart type={ChartType} data={data} />
                </div>
              </Spin>
            </TabPane>
            <TabPane tab="Data table" key="2">
              <Datatable />
            </TabPane>
            <TabPane tab="Graph" key="3">
              <span className="text-red-500">
                ยังไม่มีรายละเอียดการแสดงข้อมูลของ Graph
              </span>
              {/* <Graph /> */}
            </TabPane>
            <TabPane tab="Description" key="4">
              <Description />
            </TabPane>
          </Tabs>
        </Card>
        <Card className="border-none rounded-lg px-6 py-3 max-h-screen-70 overflow-y-auto">
          <div className="flex justify-between items-baseline pb-3">
            <h1 className="font-bold text-base"></h1>
          </div>
          <Filter />
        </Card>
      </div>
    </ActivityContext.Provider>
  );
}

export { ActivityContext };
